import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UserAssignmentPage from "../user_assignment/UserAssignment.Page";
import ExtraQuiz from "../extra_quiz/ExtraQuiz.Page";

// Components
import MuiHeader from "../../components/MuiHeader";
import ExtraModulePage from "./ExtraModule.Page";
import ExtraAssignmentPage from "../ExtraAssignment/ExtraAssignment.Page";

// MUI
import {
  AppBar,
  Button,
  Box,
  Tabs,
  Tab,
  Typography,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  const navigate = useNavigate();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

function ExtraPage() {
  // ------------------------ Tabs --------------------------
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };
  // --------------------------------------------------------

  // ---------------- navigate to topic and assignment page ------
  const navigate_to = () => {
    navigate("/extratopicpage");
  };
  const navigate_too = () => {
    navigate("/user-assignment");
  };

  const navigate = useNavigate();
  // --------------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="Extra Modules" />
        <div>
          <Button onClick={navigate_too} variant="outlined" size="small">
            <b style={{ color: "black" }}>Assignment</b>
          </Button>
        </div>
        <div>
          <Button onClick={navigate_to} variant="outlined" size="small">
            <b style={{ color: "black" }}>Topic</b>
          </Button>
        </div>
        <br />
        <br />
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <AppBar position="static" style={{ background: "#2E3B55" }}>
            <Tabs
              value={tabIndex}
              onChange={onTabChange}
              indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Content" {...a11yProps(0)} />
              <Tab label="Quiz" {...a11yProps(1)} />
              {/* <Tab label="Extra Module" {...a11yProps(2)} /> */}
            </Tabs>
          </AppBar>
          <div
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={tabIndex}
            onChangeIndex={onTabIndexChange}
          >
            <TabPanel value={tabIndex} index={0} dir={theme.direction}>
              <ExtraModulePage />
            </TabPanel>
            <TabPanel value={tabIndex} index={1} dir={theme.direction}>
              <ExtraQuiz />
            </TabPanel>
          </div>
        </Box>
      </div>
    </>
  );
}

export default ExtraPage;
